export enum ReportStatus {
  REPORT_AVAILABLE = 'A',
  REPORT_NOT_AVAILABLE = 'N',
}
